module.exports = __webpack_public_path__ + "static/media/react-bootstrap-logo.83fe61b0.svg";